import { render, staticRenderFns } from "./DocumentTypesList.vue?vue&type=template&id=da1d8ca2&scoped=true&"
import script from "./DocumentTypesList.vue?vue&type=script&lang=js&"
export * from "./DocumentTypesList.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypesList.vue?vue&type=style&index=0&id=da1d8ca2&lang=scss&scoped=true&"
import style1 from "./DocumentTypesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1d8ca2",
  null
  
)

export default component.exports